<template>
    <div class="sidebar-detail">
        <!-- :title="`${detailInfo.name || '----' } ${qrCode}`" -->
        <detail-header
            v-if="detailInfo"
            title="Germplasm"
            @refreshDetailPage="refreshDetailPage"
            @closeDetailPage="closeDetailPage"
        />

        <div>
            <p class="detail-title">Details</p>
            <div>
                <table class="recording-detail-table">
                    <tr>
                        <td>Id</td>
                        <td>{{ detailInfo.id }}</td>
                    </tr>
                    
                    <tr>
                        <td>Progeny Code</td>
                        <td>{{ (detailInfo.progeny||{}).code }}</td>
                    </tr>
                    <tr>
                        <td>Species</td>
                        <td>{{ (detailInfo.species||{}).name || "-" }}</td>
                    </tr>
                    <tr>
                        <td>Fruit Type</td>
                        <td>{{ (detailInfo.fruitType||{}).name || "-" }}</td>
                    </tr>
                    <tr>
                        <td>Fruit Color</td>
                        <td>{{ (detailInfo.fruitColour||{}).name || "-" }}</td>
                    </tr>
                    <tr>
                        <td>Height</td>
                        <td>{{ detailInfo.height || "-" }}</td>
                    </tr>
                    <tr>
                        <td>Economic Use</td>
                        <td>{{ detailInfo.economicUse || "-" }}</td>
                    </tr>

                    <tr>
                        <td class="table-section" colspan="2">Bunch</td>
                    </tr>
                    <tr>
                        <td>Bunch Weight</td>
                        <td>{{ detailInfo.bunchWeight || "-" }}</td>
                    </tr>
                    <tr>
                        <td>Bunch Breath</td>
                        <td>{{ addTo2Decimal(detailInfo.bunchBreath) || "-" }}</td>
                    </tr>
                    <tr>
                        <td>Bunch Depth</td>
                        <td>{{ addTo2Decimal(detailInfo.bunchDepth) || "-" }}</td>
                    </tr>
                    <tr>
                        <td>Bunch Length</td>
                        <td>{{ addTo2Decimal(detailInfo.bunchLength) || "-" }}</td>
                    </tr>
                    <tr>
                        <td>Bunch Spine Characteristic</td>
                        <td>{{ detailInfo.bunchSpineCharacteristic || "-" }}</td>
                    </tr>
                    <tr>
                        <td>Bunch Remarks</td>
                        <td>{{ detailInfo.bunchRemarks || "-" }}</td>
                    </tr>

                    <tr>
                        <td class="table-section" colspan="2">Leaflet</td>
                    </tr>
                    <tr>
                        <td>Leaflet Count</td>
                        <td>{{ detailInfo.leafletCount || "-" }}</td>
                    </tr>
                    <tr>
                        <td>Leaflet Width</td>
                        <td>{{ addTo2Decimal(detailInfo.leafletWidth) || "-" }}</td>
                    </tr>
                    <tr>
                        <td>Leaflet Length</td>
                        <td>{{ addTo2Decimal(detailInfo.leafletLength) || "-" }}</td>
                    </tr>
                    
                    <tr>
                        <td class="table-section" colspan="2">Rachis</td>
                    </tr>
                    <tr>
                        <td>Stem</td>
                        <td>{{ detailInfo.v || "-" }}</td>
                    </tr>
                    <tr>
                        <td>Rachis Depth</td>
                        <td>{{ addTo2Decimal(detailInfo.rachisDepth) || "-" }}</td>
                    </tr>
                    <tr>
                        <td>Rachis Width</td>
                        <td>{{ addTo2Decimal(detailInfo.rachisWidth) || "-" }}</td>
                    </tr>
                    <tr>
                        <td>Rachis Length</td>
                        <td>{{ addTo2Decimal(detailInfo.rachisLength) || "-" }}</td>
                    </tr>
                    
                    <tr>
                        <td class="table-section" colspan="2">Sampling</td>
                    </tr>
                    <tr>
                        <td>Accession Number</td>
                        <td>{{ detailInfo.accessionNumber || "-" }}</td>
                    </tr>
                    <tr>
                        <td>Accession Date</td>
                        <td>{{ formatDate(detailInfo.accessionDate) }}</td>
                    </tr>
                    <tr>
                        <td>Count Number</td>
                        <td>{{ detailInfo.countNumber || "-" }}</td>
                    </tr>
                    <tr>
                        <td>Sample Number</td>
                        <td>{{ detailInfo.sampleNumber || "-" }}</td>
                    </tr>
                    <tr>
                        <td>Sample Chatacrer</td>
                        <td>{{ detailInfo.sampleCharacter || "-" }}</td>
                    </tr>
                    <tr>
                        <td>Population Size</td>
                        <td>{{ detailInfo.populationSize || "-" }}</td>
                    </tr>
                    <tr>
                        <td>Ecology</td>
                        <td>{{ detailInfo.ecology || "-" }}</td>
                    </tr>
                    <tr>
                        <td>Photograph</td>
                        <td>{{ detailInfo.photograph === true ? "Yes" : "No" }}</td>
                    </tr>
                    <tr>
                        <td>Collector</td>
                        <td>{{ detailInfo.collector || "-" }}</td>
                    </tr>

                    <tr>
                        <td class="table-section" colspan="2">Location</td>
                    </tr>
                    <tr>
                        <td>Latitude</td>
                        <td>{{ detailInfo.latitude || "-" }}</td>
                    </tr>
                    <tr>
                        <td>Longitude</td>
                        <td>{{ detailInfo.longitude || "-" }}</td>
                    </tr>
                    <tr>
                        <td>Altitude</td>
                        <td>{{ detailInfo.altitude || "-" }}</td>
                    </tr>
                    <tr>
                        <td>Location</td>
                        <td>{{ (detailInfo.location||{}).name || "-" }}</td>
                    </tr>
                    <tr>
                        <td>Village</td>
                        <td>{{ detailInfo.village || "-" }}</td>
                    </tr>
                    <tr>
                        <td>Province</td>
                        <td>{{ detailInfo.province || "-" }}</td>
                    </tr>
                    <tr>
                        <td>Country</td>
                        <td>{{ (detailInfo.country||{}).name || "-" }}</td>
                    </tr>
                </table>
            </div>

            <p class="detail-title detail-title-pd">Date Time</p>
            <div class="user-datetime-container">
                <table>
                    <tr>
                        <td>Modified</td>
                        <td>{{ $_getDateTimeFormat(detailInfo.lastModificationTime) }} {{ $t('detail.by') }} {{ (detailInfo.lastModifierUser||{}).userName || '-' }}</td>
                    </tr>
                    <tr>
                        <td>Created</td>
                        <td>{{ $_getDateTimeFormat(detailInfo.creationTime) }} {{ $t('detail.by') }} {{ (detailInfo.creatorUser||{}).userName || '-' }}</td>
                    </tr>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import DetailHeader from "./DetailHeader";
import { germplasmGet } from "@/api/germplasm";

export default {
    components: {
        "detail-header": DetailHeader,
    },
    props: {
        infoSidebarId: {
            type: Number | String
        }
    },
    data() {
        return {
            detailInfo: null
        };
    },
    watch: {
        infoSidebarId: {
            immediate: true,
            handler() {
                this.getDetails();
            },
        }
    },
    methods: {
        async getDetails() {
            if (this.infoSidebarId) {
                var res = await germplasmGet({ Id: this.infoSidebarId });
                if (res) {
                    this.detailInfo = res;
                }
            }
        },
        refreshDetailPage() {
            this.getDetails();
        },
        closeDetailPage() {
            this.$store.dispatch("info_sidebar/setInfoSidebar");
        }
    }
};
</script>

<style scoped>
.stepper-container {
    padding: var(--space-16) 0;
}
</style>


// WEBPACK FOOTER //
// src/components/SidebarDetail/GermplasmSidebar.vue